import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../services/theme.service';
import { AuthService, Empresa } from '../../services/apis/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-profile-menu',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './profile-menu.component.html',
    styleUrls: ['./profile-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileMenuComponent implements OnInit {
    @Output() close = new EventEmitter<void>();

    userName = '';
    currentEmpresa = '';
    otherEmpresas: Empresa[] = [];
    isSwitching = false;
    switchError = '';

    constructor(
        public themeService: ThemeService,
        private authService: AuthService,
        private router: Router,
        private cdr: ChangeDetectorRef
    ) { }

    baseName = '';

    ngOnInit() {
        this.userName = this.authService.getUserName() || '';
        this.currentEmpresa = this.authService.getEmpresaDescricao() || '';
        this.baseName = this.authService.getBaseAcessoDescricao() || '';
        const currentEmpresaId = this.authService.getEmpresaId();
        this.otherEmpresas = this.authService.getAvailableEmpresas()
            .filter(e => e.id !== currentEmpresaId);
    }

    toggleTheme(event: Event) {
        event.stopPropagation();
        this.themeService.toggleTheme();
    }

    switchEmpresa(event: Event, empresa: Empresa) {
        event.stopPropagation();
        if (this.isSwitching) return;
        this.isSwitching = true;
        this.switchError = '';
        this.cdr.markForCheck();

        this.authService.switchEmpresa(empresa.id).subscribe({
            next: (response) => {
                this.isSwitching = false;
                if (response.success) {
                    this.close.emit();
                    this.router.navigate(['/home']).then(() => {
                        window.location.reload();
                    });
                } else {
                    this.switchError = response.message || 'Não foi possível trocar de empresa.';
                    this.cdr.markForCheck();
                }
            },
            error: () => {
                this.isSwitching = false;
                this.switchError = 'Erro ao trocar de empresa.';
                this.cdr.markForCheck();
            }
        });
    }

    logout(event: Event) {
        event.stopPropagation();
        this.authService.logout();
        this.close.emit();
        this.router.navigate(['/login'], { replaceUrl: true });
    }
}
